
class LocalStorageClass {
  
  getItem(key: string) {
    const value = localStorage.getItem(key);
    return value !== 'undefined' ? JSON.parse(value) : null;
  }

  setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clearAllStorage() {
    localStorage.clear();
  }

}

export const LocalStorageService = new LocalStorageClass();